const looksLikeHtml = (body) => /^\s*</.test(body);

const defaultWait = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

export const createRetryingRequest = ({
  fetchImpl = fetch,
  retries = 4,
  initialBackoff = 400,
  wait = defaultWait,
  onRecovered = () => {},
} = {}) => {
  return (options, url, payload, callback) => {
    const attempt = () => fetchImpl(url)
      .then((response) => {
        if (!response.ok) throw new Error(`failed loading ${url}; status ${response.status}`);
        return response.text();
      })
      .then((data) => {
        if (looksLikeHtml(data)) throw new Error(`failed loading ${url}; received HTML instead of JSON`);
        return data;
      });

    const retryInBackground = (remaining, backoff) => {
      if (remaining <= 0) return undefined;

      return wait(backoff)
        .then(attempt)
        .then((data) => onRecovered(url, data))
        .catch(() => retryInBackground(remaining - 1, backoff * 2));
    };

    attempt()
      .then((data) => callback(null, { status: 200, data }))
      .catch((error) => {
        callback(error.message || 'failed loading translations', { status: 404 });
        retryInBackground(retries, initialBackoff);
      });
  };
};
